import { TrashIcon } from '@heroicons/react/24/outline';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import Button from 'components/inputs/button';
import { clearConfigurationLinesets } from 'features/configurations';
import { useCallback } from 'react';
import {
  RESET_LINESETS_CONFIRM_BUTTON,
  RESET_LINESETS_CONFIRM_MESSAGE,
  RESET_LINESETS_CONFIRM_TITLE
} from 'utils/reset-linesets-confirmation';
import { confirmationModal } from 'utils/ui';

export default function ResetLinesetsButton() {
  const dispatch = useAppDispatch();
  const { configurations, activeConfig } = useAppSelector(
    (state) => state.configurations
  );

  const activeConfiguration = configurations[activeConfig];
  const configurationId = activeConfiguration?.uniqueId;
  const hasLinesets = (activeConfiguration?.lineSets?.length ?? 0) > 0;

  const handleClick = useCallback(() => {
    if (!configurationId) return;

    confirmationModal(
      RESET_LINESETS_CONFIRM_MESSAGE,
      () => {
        dispatch(clearConfigurationLinesets({ configurationId }));
      },
      RESET_LINESETS_CONFIRM_TITLE,
      undefined,
      RESET_LINESETS_CONFIRM_BUTTON
    );
  }, [configurationId, dispatch]);

  return (
    <Button
      color='white'
      disabled={!hasLinesets}
      icon={TrashIcon}
      iconSize='sm'
      onClick={handleClick}
      text='Reset line sets'
      fullWidth
    />
  );
}
